import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { updateSnackbar } from "../../../../_redux/SnackbarSlice";
import * as _props from "../../../../_redux/_services/JobPostingSlice";
import JobpostingDetailsPortals from "./JobpostingDetailsPortals";

import { GetUserInfo } from "../../../../_utilities/getUserInfo";
const initalState = { data: null, message: "", isloader: true };

const JobpostingDetailsPortalsEdit = ({ onReceiveHandler, selectedJobId }) => {
  const [listOfPF, setListOfPF] = useState(
    JSON.parse(JSON.stringify(listOfPlatform)),
  );
  const [flatFee, setFlatFee] = useState("");
  const [flatFeeCountryId, setFlatFeeCountryId] = useState("");
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [defaultflatFee, setDefaultFlatFee] = useState("0");
  const [defaultflatFeeCountryId, setDefaultFlatFeeCountryId] = useState("0");
  const [jobId, setJobId] = useState(null);
  const [updateData, setUpdateData] = useState([]);
  const [isSegments, setIsSegments] = useState(true);

  const getDetails = useSelector((state) => state.Jobpostingsbyid.data);
  const updateCode = useSelector((state) => state.Editjobpostings.data);
  const portalsCode = useSelector((state) => state.UpdatePortals.data);
  const vendorsRes = useSelector((state) => state.GetListVendors?.data);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const updateHandler = (val, type) => {
    let finalData = JSON.parse(JSON.stringify(updateData));
    if (type === "flatFee") {
      finalData.flatFee = val;
      setFlatFee(val);
    } else if (type === "vendor") {
      setSelectedVendors(val.map((x) => x.id));
      finalData.vendorIds = val.map((x) => x.id);
    }
    setUpdateData(finalData);
  };

  const updateCountryHandler = (val) => {
    let finalData = JSON.parse(JSON.stringify(updateData));
    finalData.flatFeeCountryId = val;
    setUpdateData(finalData);
    setFlatFeeCountryId(val);
  };

  useEffect(() => {
    async function init() {
      let userDetails = await GetUserInfo();
      let val =
        userDetails[0].flatFee !== null && userDetails[0].flatFee !== 0
          ? userDetails[0].flatFee
          : "";
      let CountryVal =
        userDetails[0].flatFeeCountryId !== null &&
        userDetails[0].flatFeeCountryId !== 0
          ? userDetails[0].flatFeeCountryId
          : "";
      setDefaultFlatFee(val);
      setDefaultFlatFeeCountryId(CountryVal);
    }
    init();
  }, []);

  const onChangePlatformHandler = (e, item, isSegments) => {
    let data = JSON.parse(JSON.stringify(listOfPF));
    let finalData = JSON.parse(JSON.stringify(updateData));
    let Index = data.findIndex((x) => x.id === item.id);
    if (Index !== -1) {
      data[Index].checked = e.target.checked;
      data[Index].value = e.target.checked ? 1 : 0;
      setListOfPF(data);
    }
    finalData[item.name] = e.target.checked ? 1 : 0;
    setUpdateData(finalData);
    setIsSegments(isSegments);
  };

  // getData
  useEffect(() => {
    if (selectedJobId) {
      dispatch(_props.jobpostingsbyidAsync(selectedJobId));
    }
  }, [selectedJobId]);

  useEffect(() => {
    if (getDetails !== null && getDetails !== undefined) {
      let postingData = JSON.parse(JSON.stringify(getDetails));
      let portals = JSON.parse(JSON.stringify(listOfPF));
      portals[0].value = postingData.CSPortal;
      portals[0].checked = parseInt(postingData.CSPortal) === 1 ? true : false;
      portals[1].value = postingData.VSPortal;
      portals[1].checked = parseInt(postingData.VSPortal) === 1 ? true : false;
      portals[2].value = postingData.EPortal;
      portals[2].checked = parseInt(postingData.EPortal) === 1 ? true : false;
      portals[3].value = postingData.JBPortal;
      portals[3].checked = parseInt(postingData.JBPortal) === 1 ? true : false;
      setIsSegments(parseInt(postingData.JBPortal) === 1 ? false : true);
      postingData.flatFee =
        postingData?.flatFee && parseInt(postingData.CSPortal) === 1
          ? postingData.flatFee
          : defaultflatFee;
      postingData.flatFeeCountryId =
        postingData?.flatFeeCountryId && parseInt(postingData.CSPortal) === 1
          ? postingData.flatFeeCountryId
          : defaultflatFeeCountryId;
      setJobId(postingData.id);
      setFlatFee(
        postingData?.flatFee && parseInt(postingData.CSPortal) === 1
          ? postingData.flatFee
          : defaultflatFee,
      );
      setFlatFeeCountryId(
        postingData?.flatFeeCountryId && parseInt(postingData.CSPortal) === 1
          ? postingData.flatFeeCountryId
          : defaultflatFeeCountryId,
      );
      try {
        postingData.vendorIds = JSON.parse(postingData.vendorIds);
      } catch (e) {
        postingData.vendorIds = postingData.vendorIds
          ? postingData.vendorIds.split(",").map(Number)
          : [];
      }
      setUpdateData(postingData);
      setListOfPF(portals);
      setSelectedVendors(postingData.vendorIds);
      dispatch(_props.jobpostingsbyidStartReducer(initalState));
    }
  }, [getDetails]);

  const onSavePortalHandler = async () => {
    let data = JSON.parse(JSON.stringify(listOfPF));
    let finalData = JSON.parse(JSON.stringify(updateData));
    let Index = data.findIndex((x) => x.name === "JBPortal");

    if (
      isSegments &&
      finalData["JBPortal"] === 1 &&
      (!finalData.segmentId || finalData.segmentId === 0)
    ) {
      if (Index !== -1) {
        data[Index].checked = false;
        data[Index].value = 0;
        setListOfPF(data);
      }
      finalData["JBPortal"] = 0;
      setUpdateData(finalData);
      dispatch(
        updateSnackbar({
          type: "error",
          message: "Please select a suitable segment in the job details page",
        }),
      );
      return;
    }

    const activeVendorsCount = vendorsRes
      ? vendorsRes.filter((x) => x?.vendorStatus === 1).length
      : 0;

    if (
      finalData.VSPortal === 1 &&
      activeVendorsCount >= 1 &&
      (!finalData.vendorIds || finalData.vendorIds.length === 0)
    ) {
      dispatch(
        updateSnackbar({
          type: "error",
          message: "Please select the vendors",
        }),
      );
      return;
    }
    // dispatch(_props.editjobpostingsAsync(jobId, updateData));
    let portalData = {
      VSPortal: finalData.VSPortal,
      EPortal: finalData.EPortal,
      CSPortal: finalData.CSPortal,
      JBPortal: finalData.JBPortal,
      vendorIds:
        finalData?.vendorIds?.length === 0 || finalData?.vendorIds?.includes(0)
          ? "[0]"
          : JSON.stringify(finalData.vendorIds),
      flatFee: finalData.flatFee,
      flatFeeCountryId: finalData.flatFeeCountryId,
    };
    dispatch(_props.updatePortalsAsync(jobId, portalData));
  };

  useEffect(() => {
    if (portalsCode === 200) {
      dispatch(_props.updatePortalsStartReducer(initalState));
      // navigate(`/ats/layout/jobpostings/portals/view/${jobId}`);
      onReceiveHandler(false);
    }
  }, [portalsCode, dispatch]);

  return (
    <>
      <div className="actionBtnRtl1" style={{ marginTop: "-12px" }}>
        <Button
          variant="text"
          className="buttonHover"
          style={{
            color: "red",
            width: "100px",
            fontWeight: "bolder",
            margin: "0px",
          }}
          onClick={() => {
            onReceiveHandler(false);
          }}
        >
          <Link
            href="#"
            style={{ color: "red", fontSize: "14px" }}
            underline="always"
          >
            {" "}
            Cancel
          </Link>
        </Button>
        <Button
          variant="contained"
          size="small"
          className="buttonHover1"
          style={{
            backgroundColor: "var(--primary-bg-color) ",
            color: "var(--primary-background-text-color)",
            borderRadius: "10px",
            width: "96px",
            textTransform: "capitalize",
          }}
          onClick={onSavePortalHandler}
        >
          Save
        </Button>
      </div>
      <JobpostingDetailsPortals
        componentType="Edit"
        onReceiveHandler={onChangePlatformHandler}
        data={listOfPF}
        flatFee={flatFee}
        flatFeeCountryId={flatFeeCountryId}
        vendors={selectedVendors}
        updateHandler={updateHandler}
        updateCountryHandler={updateCountryHandler}
      />
    </>
  );
};

export default JobpostingDetailsPortalsEdit;

const listOfPlatform = [
  {
    id: 3,
    name: "CSPortal",
    title: "Cloud Sourcing Platform",
    checked: false,
    value: 0,
  },
  {
    id: 2,
    name: "VSPortal",
    title: "Vendor Sourcing Platform",
    checked: false,
    value: 0,
  },
  {
    id: 4,
    name: "EPortal",
    title: "Employee Platform",
    checked: false,
    value: 0,
  },
  {
    id: 5,
    name: "JBPortal",
    title: "Job Board Platform",
    checked: false,
    value: 0,
  },
];
